export const DRAFT = 'DRAFT'
export const SUBMITTED = 'SUBMITTED'

export const applicationStatuses = {
  DRAFT,
  SUBMITTED,
}
